@if (fileContent || isEmptyFile) {
<div>
    <div mat-dialog-title class="mat-title">
      {{'third_party_notices_title' | translate}}
      <div (click)="onCancelClick()">
        <span class="close-dialog">&#10006;</span>
      </div>
    </div>

    @if (fileContent) {
    <mat-dialog-content class="mat-content">
      <p [innerText]="fileContent" class="notices"></p>
    </mat-dialog-content>
    }

    @if (isEmptyFile) {
    <mat-dialog-content class="mat-content">
      <p class="notices">{{'no_content_message' | translate}}</p>
    </mat-dialog-content>
    }
</div>
}

@if (!fileContent  && !isEmptyFile) {
<app-spinner>
</app-spinner>
}